import { useRef } from "react";
import { Camera, ImagePlus, X } from "lucide-react";

const shrink = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    const k = Math.min(1, 1600 / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    resolve(c.toDataURL("image/jpeg", 0.85));
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("bad image")); };
  img.src = url;
});

export const PhotoBox = ({ id, title, hint, value, onChange, labels, onError }) => {
  const cam = useRef(null);
  const gal = useRef(null);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    try { onChange(await shrink(f)); } catch (err) { onError(); }
  };
  return (
    <div className="space-y-3 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200" data-testid={`photo-box-${id}`}>
      <div>
        <p className="font-semibold text-slate-900">{title}</p>
        {hint && <p className="mt-1 text-xs leading-relaxed text-amber-700" data-testid={`photo-hint-${id}`}>{hint}</p>}
      </div>
      {value ? (
        <div className="relative">
          <img src={value} alt={title} className="max-h-64 w-full rounded-xl object-contain ring-1 ring-slate-200" data-testid={`photo-preview-${id}`} />
          <button type="button" onClick={() => onChange("")} className="absolute right-2 top-2 rounded-full bg-black/60 p-1.5 text-white" aria-label={labels.remove} data-testid={`photo-remove-${id}`}><X size={16} /></button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          <button type="button" onClick={() => cam.current.click()} className="flex flex-col items-center gap-1.5 rounded-xl border-2 border-dashed border-slate-300 py-5 text-sm text-slate-700 transition-colors hover:border-[#2F5BFF] hover:text-[#2F5BFF]" data-testid={`photo-camera-${id}`}><Camera size={22} />{labels.camera}</button>
          <button type="button" onClick={() => gal.current.click()} className="flex flex-col items-center gap-1.5 rounded-xl border-2 border-dashed border-slate-300 py-5 text-sm text-slate-700 transition-colors hover:border-[#2F5BFF] hover:text-[#2F5BFF]" data-testid={`photo-gallery-${id}`}><ImagePlus size={22} />{labels.gallery}</button>
        </div>
      )}
      <input ref={cam} type="file" accept="image/*" capture="environment" className="hidden" onChange={pick} data-testid={`photo-input-camera-${id}`} />
      <input ref={gal} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`photo-input-gallery-${id}`} />
    </div>
  );
};
